<div class="gauge-container">
  <ngx-gauge
    type="semi"
    [value]="gaugeValue"
    [label]="gaugeLabel"
    [append]="gaugeAppendText"
    [size]="30"
    [thick]="3"
    [min]="0"
    [max]="14"
    cap="butt"
    [thresholds]="thresholdConfig"
    backgroundColor="white"
    style="color: transparent; padding-right: 90px"
  >
  </ngx-gauge>
  <img src="assets/img/ph-guage.svg" alt="Image Label" class="centered-image" />
</div>
